<template>
  <SectionContainer
    v-for="(section, index) in sections"
    :key="section.id"
    :bg-color="section.background ? 'light' : undefined"
    class="product-overview-section"
    height="md"
  >
    <SHeading :color="titleColor" level="2" size="2">
      {{ section.title }}
    </SHeading>

    <div class="product-overview-section__cards">
      <PCard v-for="group in section.groups" :key="group.id" flat>
        <template #title>{{ group.title }}</template>

        <div class="product-overview-section__products">
          <SButton
            v-for="product in group.products"
            :key="product.id"
            action-type="quaternary"
            :prefix-icon="product.icon"
            size="sm"
            :tag="NuxtLink"
            text-align="left"
            :to="product.url"
          >
            {{ product.name }}
          </SButton>
        </div>
      </PCard>
    </div>

    <SButton
      v-if="showAllButton && index === sections.length - 1"
      action-type="tertiary"
      class="product-overview-section__cta"
      suffix-icon="far fa-arrow-right"
      :tag="NuxtLink"
      :to="ziggy('mainSite.productOverview')"
    >
      {{ tr("client.homepage.product_list_all_products") }}
    </SButton>
  </SectionContainer>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";

import { SButton } from "@solvari/common-fe";
import { PCard, SHeading } from "@solvari/components";
import { useI18nMainSiteHomepage } from "@solvari/translations";

import SectionContainer from "~/shared/components/SectionContainer.vue";
import { ziggy } from "~/shared/libs/ziggy.ts";

const { tr } = useI18nMainSiteHomepage();

type Section = {
  background: boolean;
  groups: {
    id: string;
    products: { icon: string; id: string; name: string; url: string }[];
    title: string;
  }[];
  id: string;
  title: string;
};

defineProps<{
  sections: Section[];
  showAllButton?: boolean;
  titleColor?: "gray" | "primary" | "white";
}>();
</script>

<style lang="postcss">
.product-overview-section {
  &__cards {
    @apply grid gap-4 grid-cols-auto-56 grid-cols-auto-grow;

    .p-card-title {
      @apply -mx-5 border-b border-gray-100 px-5 pb-3 text-base font-semibold uppercase text-primary-700;
    }

    .p-card-body {
      @apply py-3;
    }
  }

  &__products {
    @apply -mx-3 flex flex-col gap-2;
  }

  &__cta {
    @apply mx-auto mt-4;
  }

  .s-app-container {
    @apply flex flex-col;
  }
}
</style>
